import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCirclePlaceholderOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCirclePlaceholderOff"><Path d="M20.4816 17.2999C21.4438 15.7634 22 13.9466 22 12C22 6.47715 17.5229 2 12 2C10.0534 2 8.23663 2.55623 6.70007 3.51842L20.4816 17.2999Z" fill="currentColor"/><Path d="M3.53039 2.46967L2.46973 3.53033L4.41831 5.47891C2.9117 7.22925 2 9.5086 2 11.9997C2 17.5226 6.47715 21.9997 12 21.9997C14.4911 21.9997 16.7705 21.088 18.5208 19.5814L20.4697 21.5303L21.5304 20.4697L3.53039 2.46967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCirclePlaceholderOff;
